import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { userApi, userApi_Live } from 'apis/operation/userApis';
import { userSearchOptionList } from 'utils/constant';
import { IUserProps } from 'utils/types/common';
import DefaultLayout from 'components/layout/DefaultLayout';
import TableToolbar from 'components/table/TableToolbar';
import RegisterButton from 'components/button/RegisterButton';
import MainTable from 'components/table/MainTable';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import TextButton from 'components/button/TextButton';
import { useTranslation } from 'react-i18next';
/**
 * * 운영 - 유저 목록
 */

interface ISearchProps {
  searchType: string;
  searchWord: string | undefined;
}

const UserListPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies, setCookie] = useCookies();
  const [searchData, setSearchData] = useState<ISearchProps>({
    searchType: 'uid',
    searchWord: '',
  });
  const [userListData, setUserListData] = useState<IUserProps[]>();

  /// 검색 조건
  const handleSearchChange = (value: string) => {
    setSearchData({ ...searchData, searchType: value });
  };

  /// 검색 조건 input
  const handleSearchInput = (e) => {
    setSearchData({ ...searchData, searchWord: e.target.value });
  };

  /// 상세보기 클릭
  const handleDetailClick = (record) => () => {
    // 구 코드에 연결됨
    setCookie('userDetailInfo', JSON.stringify(record), { expire: 0 } as any);
    navigate(`/user/${record.userkey}/detail`, {
      state: {
        record: record,
        currentPage: location?.hash,
      },
    });
  };

  /// 데이터 불러오기
  const fetchData = async () => {
    const res =
      cookies.server === 'test'
        ? await userApi.read(searchData)
        : await userApi_Live.read(searchData);
    // console.log(res);
    setUserListData(res);
    if (!res) {
      return false;
    }
  };

  const columnsOrigin = [
    {
      title: t('user.table.userCountry'),
      dataIndex: 'country',
      width: '6rem',
      sorter: (a, b) => a.country.localeCompare(b.country),
    },
    {
      title: 'UID',
      dataIndex: 'uid',
      width: '7.5rem',
      sorter: (a, b) => a.uid.localeCompare(b.uid),
      render: (text, record) => (
        <TextButton onClick={handleDetailClick(record)}>{text}</TextButton>
      ),
    },
    {
      title: t('user.table.nickname'),
      dataIndex: 'nickname',
      width: '10.5rem',
      sorter: (a, b) => a.nickname.localeCompare(b.nickname),
      render: (text, record) => (
        <Link to={{ pathname: `/user/${record.userkey}/detail` }}>{text}</Link>
      ),
    },
    {
      title: t('user.table.gameBaseID'),
      dataIndex: 'gamebaseid',
      width: '11.5rem',
      sorter: (a, b) => a.gamebaseid.localeCompare(b.gamebaseid),
      render: (text, record) => (
        <Link to={{ pathname: `/user/${record.userkey}/detail` }}>{text}</Link>
      ),
    },
    {
      title: t('user.table.initialJoinDate'),
      dataIndex: 'createtime',
      width: '11.5rem',
      sorter: (a, b) => a.createtime.localeCompare(b.createtime),
    },
    {
      title: t('user.table.lastAccessDate'),
      dataIndex: 'lastlogintime',
      width: '11.5rem',
      sorter: (a, b) => a.lastlogintime.localeCompare(b.lastlogintime),
    },
    {
      title: t('user.table.ownedGems'),
      dataIndex: 'gem',
      width: '6.5rem',
      sorter: (a, b) => a.gem - b.gem,
    },
    {
      title: t('user.table.ownedRaffleTickets'),
      dataIndex: 'coin',
      width: '8rem',
      sorter: (a, b) => a.coin - b.coin,
    },
    {
      title: t('user.table.status'),
      dataIndex: 'valid',
      width: '4rem',
      align: 'center',
    },
    // {
    //   title: '조회',
    //   dataIndex: 'view',
    //   width: '5rem',
    // render: (text, record) => (
    // <CapsuleButton view onClick={handleDetailClick(record)}>
    //   {/* <img src={userIcon} alt="상세보기" /> */}
    // </CapsuleButton>
    // ),
    // },
  ];
  useEffect(() => {
    fetchData().catch(console.error);
  }, [searchData, cookies.server]);
  return (
    <DefaultLayout>
      <TableToolbar>
        <div>
          <DefaultSelect
            optionList={userSearchOptionList}
            onChange={handleSearchChange}
            value={searchData.searchType}
            style={{ marginRight: '1rem', width: '10rem' }}
          />
          <DefaultInput
            placeholder={t('user.header.conditionSelectionPlaceholder')}
            onChange={handleSearchInput}
            value={searchData.searchWord}
          />
        </div>
        <RegisterButton onClick={handleDetailClick}>
          {t('user.header.sendMail')}
        </RegisterButton>
      </TableToolbar>
      <MainTable columns={columnsOrigin} dataSource={userListData} />
    </DefaultLayout>
  );
};

export default UserListPage;
